import { Backdrop, Box } from '@mui/material';
import React from 'react';

import { LoaderStyled } from './loader.styled.tsx';

interface LoaderProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  fullscreen?: boolean;
  openBackdrop?: boolean;
}

const Loader: React.FC<LoaderProps> = ({
  size = 'md',
  fullscreen = false,
  openBackdrop = false,
}) => {
  return (
    <>
      {openBackdrop ? (
        <Backdrop
          sx={(theme) => (
            { zIndex: theme.zIndex.drawer + 1 }
          )}
          open={openBackdrop}
        >
          <LoaderStyled size={'lg'} />
        </Backdrop>
      ) : (
        <Box
          sx={(theme) => (
            {
              display: 'grid',
              position: 'relative',
              width: fullscreen ? '100%' : 'fit-content',
              height: fullscreen ? '100%' : 'fit-content',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: theme.zIndex.drawer + 1,
            }
          )}
        >
          <LoaderStyled size={fullscreen ? 'lg' : size} />
        </Box>
      )}
    </>
  );
};

export default Loader;